import StringHelper from "core/StringHelper";
import React from "react";

export function GetColumns(props, state, onOpenDialog) {
   return [
      {
         Header: "Merchant Number",
         accessor: "MerchantNumber",
      },
      {
         Header: "Legal Name",
         accessor: "LegalName",
         Cell: (row) => (row.value ? StringHelper.Capitalize(row.value, true) : ""),
      },
      {
         Header: "DBA",
         accessor: "DBA",
         Cell: (row) => (row.value ? StringHelper.Capitalize(row.value, true) : ""),
      },
      {
         Header: "Contact Name",
         accessor: "ContactName",
         Cell: (row) => (row.value ? StringHelper.Capitalize(row.value, true) : ""),
      },
      {
         Header: "E-Mail",
         accessor: "Email",
         Cell: (row) => {
            const value = row.value || "";
            if (!value || value === "N/A") return null;

            const emailValidation = row.original.EmailValidation || "";
            if (emailValidation.includes("By Client")) return value;

            return (
               <span
                  style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
                  onClick={() => onOpenDialog("Email", row.original, value)}
               >
                  {value}
               </span>
            );
         },
      },
      {
         Header: "Website",
         accessor: "Website",
         Cell: (row) => {
            const value = row.value || "";
            if (!value || value === "N/A") return null;

            const websiteValidation = row.original.WebsiteValidation || "";
            if (websiteValidation.includes("By Client")) return value;

            return (
               <span
                  style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
                  onClick={() => onOpenDialog("Website", row.original, value)}
               >
                  {value}
               </span>
            );
         },
      },
      {
         Header: "Industry",
         accessor: "Industry",
      },
      {
         Header: "Address 1",
         accessor: "Address1",
      },
      {
         Header: "Address 2",
         accessor: "Address2",
      },
      {
         Header: "Zip Code",
         accessor: "ZipCode",
         width: 80,
      },
      {
         Header: "City",
         accessor: "City",
      },
      {
         Header: "Country",
         accessor: "Country",
      },
      {
         Header: "Phone Number",
         accessor: "PhoneNumber",
         Cell: (row) => {
            const value =
               row.original.PhoneCountryCode && StringHelper.IsValidateInternationalPhone(row.original.PhoneNumber)
                  ? `+${row.original.PhoneCountryCode} ${StringHelper.GetInternationalPhoneDigits(
                       row.original.PhoneNumber
                    )}`
                  : row.value;

            if (!value) return null;

            const phoneNumberValidation = row.original.PhoneNumberValidation || "";
            if (phoneNumberValidation.includes("By Client")) return value;

            return (
               <span
                  style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
                  onClick={() => onOpenDialog("PhoneNumber", row.original, value)}
               >
                  {value}
               </span>
            );
         },
      },
      {
         Header: "KYC Status",
         accessor: "KycStatus",
         Cell: (row) => (row.value ? StringHelper.Capitalize(row.value, true) : ""),
      },
      {
         Header: "Restricted Merchant",
         accessor: "RestrictedMerchant",
         Cell: (row) => (row.value + "" == "null" ? "" : row.value + ""),
      },
      {
         Header: "Merchant Name Allowed",
         accessor: "MerchantNameAllowed",
         Cell: (row) => (row.value + "" == "null" ? "false" : row.value + ""),
      },
      {
         Header: "Web Site Validation",
         accessor: "WebsiteValidation",
         Cell: (row) => {
            const value = row.value || "";
            if (!value || value === "N/A") return null;
            return value;
         },
      },
      {
         Header: "Email Validation",
         accessor: "EmailValidation",
         Cell: (row) => {
            const value = row.value || "";
            if (!value || value === "N/A") return null;
            return value;
         },
      },
      {
         Header: "Phone # Validation",
         accessor: "PhoneNumberValidation",
         Cell: (row) => {
            const value = row.value || "";
            if (!value || value === "N/A") return null;
            return value;
         },
      },
   ];
}